import {
    IGuidance,
    IReport,
    IReportTemplate,
    IResponsibleUser,
    ReportStatus,
    ResponsibleType
} from '@shared/interfaces';

export const testResponsibleUser: IResponsibleUser = {
    id: 'test',
    fullName: 'John Doe',
    eMail: 'test@test.de',
    fullAccess: true
};

export const guidanceItem: IGuidance = {
    content:
        '<ul><li><font color="#050c05"><span>Please make sure, that major occurences which took place in your own unit, including its sub-units, but also in the assigned separate legal entities of your unit (e.g. Companies of the BizCos and Corporate Functions) are reported, where applicable and relevant.</span></font><br></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05"><span>Please list here <b>only major occurences</b>, that had to be reported <b>to the Managing Board</b> of Siemens AG, <b>and</b> which fulfilled the reporting criteria, defined in Section 5.1 of the Guidelines for Product Safety.&#160;</span></font><br></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05">In exceptional cases, where it is intended to include also other occurences voluntarily, these incidents are to be marked as such.</font></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05"><span>Please list <b>only PS-relevant occurences</b>. For example, it is not adequate to report an occurrence which caused a reputational damage for Siemens but which was not related to product safety. Major quality problems with no relevance for PS do also not belong to this reporting section.</span></font><br></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05">All <b>major incidents </b>listed in this chapter, must be <b>briefly described.</b>&#160;The reader should be able to understand the incident, its implication on PS and its current status.</font></li></ul>',
    faqSort: 1,
    fiscalYear: 2020,
    contentDe:
        '<ul><li><font color="#050c05">Bitte stellen Sie sicher, dass auch Vorkommnisse aufgef&#252;hrt werden, die sich in den Ihrer Einheit bzw. deren Untereinheiten zugeordneten rechtlich eigenst&#228;ndigen Einheiten (z.B. Gesellschaften der BizCos und der Corporate Functions) ereignet haben, sofern zutreffend und relevant.</font><br></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05">Bitte f&#252;hren Sie hier <b>nur produktsicherheitsrelevante Vorkommnisse</b> auf. Beispielsweise ist es nicht ausreichend, dass ein Vorfall eine imagesch&#228;digende Wirkung auf die Marke Siemens hat ohne dass ein Bezug zur Produktsicherheit besteht. Auch Qualit&#228;tsprobleme ohne Bezug zur Produktsicherheit geh&#246;ren nicht in diese Kategorie des PS-Jahresberichts.</font><br></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05"><span>In besonderen F&#228;llen, in denen hier zus&#228;tzlich PS-Vorf&#228;lle aufgef&#252;hrt werden sollen, die nicht den Berichtskriterien gem&#228;&#223; Abschnitt 5.1 des PS-Leitfadens entsprachen, sind diese mit einem entsprechenden Hinweis zu versehen.</span></font></li></ul><div><font color="#050c05"><br></font></div><ul><li><font color="#050c05"><span>Alle Vorf&#228;lle, die in diesem Berichtsabschnitt aufgef&#252;hrt werden, sind kurz zu beschreiben. Der Leser muss den Vorfall, seinen Bezug zur Produktsicherheit und den aktuellen Status des Falls nachvollziehen k&#246;nnen.</span></font><br></li></ul>',
    description: 'Major Product Safety Occurences',
    id: '0e96dadd5e80-4648-8743-27bebcff8810',
    responsibleType: ResponsibleType.sag,
    descriptionDe: 'Schwerwiegende Produktsicherheitsvorkommnisse'
};

export const testTemplate: IReportTemplate = {
    sections: [
        {
            title: 'Major Product Safety Occurences',
            titleDe: 'Besondere Vorkommnisse',
            areas: [
                {
                    description:
                        'Please list all major product safety occurrences (current incidents) in the Unit that had to be reported to the Managing Board of Siemens AG (Minimum reporting-criteria are defined in section 5.1 of the “Guidelines for Product Safety”):',
                    descriptionDe:
                        'Besondere Vorkommnisse (aktuelle Ereignisse) in der Einheit, die nach Abschnitt 5.1 des "Leitfaden zur Produktsicherheit" an den Vorstand der Siemens AG zu berichten waren:',
                    rows: [
                        [
                            {
                                type: 5,
                                valueId: '7fd46f5863cd-4a41-ad7e-8ede537fd55a'
                            }
                        ]
                    ]
                }
            ],
            guidance: {
                id: '1',
                content: 'Test content 1',
                contentDe: 'Test content DE 1'
            }
        },
        {
            title: 'Product Safety Audits',
            titleDe: 'Audits',
            areas: [
                {
                    description:
                        'Please confirm that the relevant product safety aspects have been included in internal audits. Give a short overview on how these audit requirements have been fulfilled:',
                    descriptionDe:
                        'Bitte bestätigen Sie, dass die relevanten Produktsicherheitsaspekte in internen Audits abgedeckt wurden. Geben Sie einen Überblick, wie die Anforderungen zur PS-Auditierung erfüllt wurden:',
                    rows: [
                        [
                            {
                                type: 5,
                                valueId: 'f70daf77e245-4467-9e75-90b49f09b642'
                            }
                        ]
                    ]
                }
            ],
            guidance: {
                id: '2',
                content: 'Test content 2',
                contentDe: 'Test content DE 2'
            }
        },
        {
            title: 'PS Improvement Measures',
            titleDe: 'Verbesserungsmaßnahmen',
            areas: [
                {
                    description:
                        'Please confirm that PS-related improvement measures have been effectively implemented and describe them in the form of a short overview:',
                    descriptionDe:
                        'Bestätigung über die Durchführung und Kontrolle von Verbesserungsmaßnahmen im Bereich der Produktsicherheit. Bitte geben Sie einen Überblick über die umgesetzten Verbesserungsmaßnahmen:',
                    rows: [
                        [
                            {
                                type: 5,
                                valueId: '9494572caf46-47f1-a1f0-3039d83126e1'
                            }
                        ]
                    ]
                }
            ],
            guidance: {
                id: '3',
                content: 'Test content 3',
                contentDe: 'Test content DE 3'
            }
        },
        {
            title: 'Product Safety System Trainings, Product Safety Training Measures',
            titleDe: 'Schulungsmaßnahmen',
            areas: [
                {
                    description:
                        'Please confirm the conduct of product safety training measures and outline what PS-related training measures have been carried out:',
                    descriptionDe:
                        'Bitte bestätigen Sie die Durchführung von PS-Schulungsmaßnahmen und beschreiben Sie, welche PS-Schulungsmaßnahmen durchgeführt wurden:',
                    rows: [
                        [
                            {
                                type: 5,
                                valueId: '6d9bb94b9a31-4a70-9a55-8cdb022c1e55'
                            }
                        ]
                    ]
                }
            ],
            guidance: {
                id: '4',
                content: 'Test content 4',
                contentDe: 'Test content DE 4'
            }
        },
        {
            title: 'Completeness and Effectiveness of the Product Safety System',
            titleDe: 'Vollständigkeit und Wirksamkeit',
            areas: [
                {
                    description:
                        'Please confirm that the completeness and effectiveness of the Product Safety system has been evaluated in your Unit (including any assigned units like Companies of the BizCos and Corporate Functions, if relevant). Describe details of conclusions, identified shortcomings and any initiated measures:',
                    descriptionDe:
                        'Ergebnisse der Bewertung von Vollständigkeit und Wirksamkeit des Systems zur Produktsicherheit der Einheit (einschließlich der zugeordneten Verbundenen Unternehmen), sowie der eingeleiteten Maßnahmen; Bitte in diesem Abschnitt auch bereits identifizierte Verbesserungsbedarfe aufführen:',
                    rows: [
                        [
                            {
                                type: 5,
                                valueId: '9c78b9a7fc4c-467a-805a-44787f649eef'
                            }
                        ]
                    ]
                }
            ],
            guidance: {
                id: '5',
                content: 'Test content 5',
                contentDe: 'Test content DE 5'
            }
        },
        {
            title: 'Affiliated Companies',
            titleDe: 'Verbundene Unternehmen',
            areas: [
                {
                    description:
                        'The contents of the following Affiliated Companies (e.g. Companies of the BizCos and Corporate Functions) have been integrated in this report:',
                    descriptionDe:
                        'Die Inhalte der Jahresberichte folgender Verbundener Unternehmen (z.B. Gesellschaften der BizCos und der Corporate Functions) wurden in diesen Bericht integriert:',
                    rows: [
                        [
                            {
                                type: 5,
                                valueId: '7ee970fd0b48-4a69-a37b-804da32f9d83'
                            }
                        ]
                    ]
                }
            ],
            guidance: {
                id: '6',
                content: 'Test content 6',
                contentDe: 'Test content DE 6'
            }
        }
    ],
    periodYear: 2020,
    description: 'First version of the template for SAG units used in 2020',
    id: 'SAG_2020#1.0',
    responsibleType: ResponsibleType.sag,
    title: 'SAG_2020'
};

export const testReport: IReport = {
    id: 'test-report-1',
    responsible: {
        orgDescription: 'Test Department',
        orgCode: 'TD',
        responsible: [testResponsibleUser],
        responsibleType: ResponsibleType.sag,
        specialists: [testResponsibleUser]
    },
    template: testTemplate,
    dueDate: new Date(new Date().getFullYear(), 9, 31).toISOString(),
    reportStartDate: new Date(new Date().getFullYear() - 1, 9, 1),
    reportEndDate: new Date(new Date().getFullYear(), 8, 30),
    reportValues: {
        '7fd46f5863cd-4a41-ad7e-8ede537fd55a': { value: '', approved: false },
        'f70daf77e245-4467-9e75-90b49f09b642': { value: 'test', approved: true },
        '9494572caf46-47f1-a1f0-3039d83126e1': { value: 'test', approved: true },
        '6d9bb94b9a31-4a70-9a55-8cdb022c1e55': { value: 'test', approved: true },
        '9c78b9a7fc4c-467a-805a-44787f649eef': { value: 'test', approved: true },
        '7ee970fd0b48-4a69-a37b-804da32f9d83': { value: 'test', approved: true }
    },
    guidanceValues: {
        '0e96dadd5e80-4648-8743-27bebcff8810': true,
        'f01f6e1be575-4cfc-8339-4dbb073e1c6b': true,
        '7ccbc573c4b6-4954-b3d7-45bf48836b45': true,
        'ea7bd66c946d-4caf-8eac-b76f6050419b': true,
        '1d94952a7106-45af-9b84-c76dc5075a0e': true,
        'c69069b73c43-4df1-8d06-7ccbbc998ca8': true
    },
    reportStatus: ReportStatus.draft,
    selectedLanguage: 'en'
};

export const testReport1: IReport = {
    ...testReport,
    id: 'test-report-2',
    responsible: {
        ...testReport.responsible,
        specialists: [{ ...testResponsibleUser, fullAccess: false }]
    },
    reportValues: {
        '7fd46f5863cd-4a41-ad7e-8ede537fd55a': { value: 'test', approved: true },
        'f70daf77e245-4467-9e75-90b49f09b642': { value: 'test', approved: true },
        '9494572caf46-47f1-a1f0-3039d83126e1': { value: 'test', approved: true },
        '6d9bb94b9a31-4a70-9a55-8cdb022c1e55': { value: 'test', approved: true },
        '9c78b9a7fc4c-467a-805a-44787f649eef': { value: 'test', approved: true },
        '7ee970fd0b48-4a69-a37b-804da32f9d83': { value: 'test', approved: true }
    }
};
